<template>
  <div>
    <transition-group name="fade" mode="out-in">

      <div key="NOTICES" class="row">
        <div v-for="notice in notices" class="col-sm-12">
          <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
            <span data-notify="icon" class="fa fa-exclamation"></span>
            <span data-notify="message">{{notice.message}}</span>
          </div>
        </div>
      </div>
      
      <div key="APPLICATIONS" v-if="$store.state.isIndividual && (applicationsLoading || (applications && applications.length > 0))" class="row">
        <div class="col-sm-12">
          <div class="card col-sm-12" v-if="applicationsLoading" v-loading="applicationsLoading" element-loading-spinner="qc-spinner">
            <div class="card-header">
              <h4 class="card-title">Application progress</h4>
            </div>
            <div class="card-content">
            </div>
          </div>
          <div v-for="application in applications" class="card col-sm-12" >
            <img class="partnerLogo" :src="application.logo" />
            <div class="card-header">
              <h4 class="card-title">Qualification verification progress for {{application ?  application.owner.name : 'an'}} application.</h4>
            </div>
            <div class="card-content">
              <div v-if="!application.verifications || application.verifications.length < 1">
              <p>Please complete your application which will be shared along with your verification results to {{application.owner.name}}.</p>
                <step-navigation :steps="buildStepsAll(application.id, null, null)" :currentStep="0" />
              </div>
              <div v-else>
                <div v-for="verification, index in application.verifications">
                  <!--<button v-if="verification.result == 'VERIFIED' || verification.result == 'NOT_VERIFIED'" @click="$store.commit('dismiss', 'v' + verification.id)" type="button" class="btn pull-right"><span class="btn-label"><i class="fa fa-times"></i>&nbsp;Dismiss</span></button>-->
                  <div>
                    <strong>{{verification.fields['firstname'] + " " + verification.fields['surname']}}</strong>
                  </div>
                  {{verification.instituteName}}
                  <step-navigation :steps="buildStepsAll(application.id, verification.id, verification.result)" :currentStep="calcStep(verification.result)" />
                </div>
                <div>Your application to {{application.owner.name}} has been submitted. You will be contacted again after it is reviewed.</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div key="VPROGRESS" v-if="$store.state.isIndividual && (verificationsLoading || nonAppVerifications.length > 0)" class="row">
        <div class="col-sm-12">
          <div class="card col-sm-12" v-loading="verificationsLoading" element-loading-spinner="qc-spinner">
            <div class="card-header">
              <h4 class="card-title">Qualification verification progress</h4>
            </div>
            <div class="card-content">
              <div v-for="verification in nonAppVerifications">
                <!--<button v-if="verification.result == 'VERIFIED' || verification.result == 'NOT_VERIFIED'" @click="$store.commit('dismiss', 'dv' + verification.id)" type="button" class="btn pull-right"><span class="btn-label"><i class="fa fa-times"></i>&nbsp;Dismiss</span></button>-->
                <div>
                  <strong>{{verification.fields['firstname'] + " " + verification.fields['surname']}}</strong>
                </div>
                {{verification.instituteName}}
                <step-navigation :steps="buildSteps(verification.id, verification.result)" :currentStep="calcStep(verification.result)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div key="VSTATS" v-if="!$store.state.isIndividual" class="row">
        <div class="col-lg-3 col-sm-6" v-for="stats in statsCards">
          <stats-card v-loading="stats.loading" element-loading-spinner="qc-spinner">
            <div class="icon-bigger text-center" :class="`icon-${stats.type}`" style="font-" slot="header">
              <i :class="stats.icon"></i>
            </div>
            <div class="numbers" slot="content">
              <p>{{stats.title}}</p>
              <div>{{stats.value}}</div>
            </div>
            <div class="stats btn-center" slot="footer">
              <!--<strong><a href="#" @click.prevent="followStatLink(stats)"><i :class="stats.footerIcon"></i> {{stats.footerText}}</a></strong>-->
              <button @click.prevent="followStatLink(stats)" class="btn btn-sm btn-fill"><i :class="stats.footerIcon"></i> {{stats.footerText}}</button>
            </div>
          </stats-card>
        </div>
      </div>


      <div key="VEDUNEW" v-if="$store.state.paymentType != 'NONE' && !$store.state.isApplicant && $store.getters.allowed('edu')" class="row">
        <div class="col-sm-12">
          <institute-select title="Education Verification" @select="$store.commit('setInitInstitute', $event); $router.push('/verification/new')" :hideIcon="false" :hidePrice="!pays" />
        </div>
      </div>

      <div key="VEMPNEW" v-if="$store.state.paymentType != 'NONE' && !$store.state.isApplicant && ($store.getters.allowed('hsc') || $store.getters.allowed('emp') || $store.getters.allowed('pli') || $store.getters.allowed('pce'))" class="row starter">
        
        <div v-if="$store.getters.allowed('hsc')" :class="'col col-md-'+(12/otherAllowedCount)">
          <div class="col-md-12 card" >
            <div class="card-header">
              <h4 class="card-title row text-center">
                <span><i class="qc2-bul fa-3x" style="width: 65px"/></span>
                </br>
                <span>High School</span>
              </h4> 
            </div>
            <div class="card-content row form-horizontal">
              <div class="col-sm-12 btn-center">
                <button class="btn btn-fill btn-wd" @click="$router.push('/verification/new?nhsc=1')">Verify</button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="$store.getters.allowed('emp')" :class="'col col-md-'+(12/otherAllowedCount)">
          <div class="col-md-12 card" >
            <div class="card-header">
              <h4 class="card-title row text-center">
                <span><i class="qc2-emp fa-3x" style="width: 65px"/></span>
                </br>
                <span>Employment History</span>
              </h4>
            </div>
            <div class="card-content row form-horizontal">
              <div class="col-sm-12 btn-center">
                <button class="btn btn-fill btn-wd" @click="$router.push('/verification/new?nemp=1')">Verify</button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="$store.getters.allowed('pli')" :class="'col col-md-'+(12/otherAllowedCount)">
          <div class="col-md-12 card" >
            <div class="card-header">
              <h4 class="card-title row text-center">                
                <span><i class="qc2-edu fa-3x" style="width: 65px"/></span>
                </br>
                <span >Professional License</span>
              </h4>
            </div>
            <div class="card-content row form-horizontal">
              <div class="col-sm-12 btn-center">
                <button class="btn btn-fill btn-wd" @click="$router.push('/verification/new?npli=1')">Verify</button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="$store.getters.allowed('pce')" :class="'col col-md-'+(12/otherAllowedCount)">
          <div class="col-md-12 card" >
            <div class="card-header">
              <h4 class="card-title row text-center">
                <span><i class="qc2-pce fa-3x" style="width: 65px"/></span>
                </br>
                <span>Professional Certificate</span>
              </h4>
            </div>
            <div class="card-content row form-horizontal">
              <div class="col-sm-12 btn-center">
                <button class="btn btn-fill btn-wd" @click="$router.push('/verification/new?npce=1')">Verify</button>
              </div>
            </div>
          </div>
        </div>
      </div>


<!--
      <div key="NEWS" class="col-sm-12">
        <news />
      </div>
-->
      <div key="VHISTORY" v-if="$store.state.paymentType != 'NONE'">
        <div class="col-sm-12">
          <verification-history />
        </div>
      </div>

      <div key="AHISTORY" v-if="$store.state.hasApplicants">
        <div class="col-sm-12">
          <applicant-history />
        </div>
      </div>

      <div key="RHISTORY" v-if="$store.state.hasReferrals">
        <div class="col-sm-12">
          <referral-history />
        </div>
      </div>

    </transition-group>
  </div>

<!--
    <div v-if="$store.state.paymentType != 'NONE'" class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Your organisation's recent activity</h4>
          </div>
          <div class="card-content row">
            <verification-history-table  />
          </div>
        </div>
      </div>
    </div>
-->
</template>

<script>
  import CircleChartCard from 'src/components/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import Loading from 'src/layout/LoadingMainPanel.vue'

  import accounting from 'accounting'

  import StepNavigation from 'src/components/Steps/StepNavigation'
  import VerificationHistory from 'src/views/Verifications/History'
  import ApplicantHistory from 'src/views/Applications/History'
  import ReferralHistory from 'src/views/Referrals/History'
  import InstituteSelect from 'src/views/Verifications/components/InstituteSelect'

  import News from 'src/views/Dashboard/News'

  accounting.settings.currency.symbol = "£";

  export default {
    name: "dashboard",
    components: {
      'applicant-history': ApplicantHistory,
      'referral-history': ReferralHistory,
      StatsCard,
      ChartCard,
      CircleChartCard,
      StepNavigation,
      InstituteSelect,
      VerificationHistory,
      News
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        notices: null,
        verifications: null,
        applications: null,
        verificationsLoading: true,
        applicationsLoading: true,
        sbBackground: this.$sidebar.sidebarBackground,
        sbFont: this.$sidebar.sidebarFont,
        sbActive: this.$sidebar.sidebarActive,
        orgStatsCards: [
          // {
          //   type: 'font',
          //   icon: 'ti-pencil',
          //   verifications: true,
          //   title: 'Incomplete',
          //   results: ['AWAITING_CONSENT'],
          //   value: 0,
          //   loading: true,
          //   footerText: 'View',
          //   footerIcon: 'fa fa-external-link',
          // },
          {
            type: 'warning',
            icon: 'fa fa-bell',
            verifications: true,
            title: 'Action Required',
            results: ['NOT_FOUND','REJECTED'],
            value: 0,
            loading: true,
            footerText: 'View',
            footerIcon: 'fa fa-external-link',
          },
          {
            type: 'warning',
            icon: 'ti-timer',
            verifications: true,
            title: 'Pending',
            results: ['PENDING'],
            value: 0,
            loading: true,
            footerText: 'View',
            footerIcon: 'fa fa-external-link',
          },
          {
            type: 'success',
            icon: 'ti-check',
            verifications: true,
            title: 'Verified',
            results: ['VERIFIED'],
            value: 0,
            loading: true,
            footerText: 'View',
            footerIcon: 'fa fa-external-link',
          },
          {
            type: 'danger',
            icon: 'ti-close',
            verifications: true,
            title: 'Not Verified',
            results: ['NOT_VERIFIED'],
            value: 0,
            loading: true,
            footerText: 'View',
            footerIcon: 'fa fa-external-link',
          }
        ],
        applicantStatsCards: [
          {
            type: 'none',
            icon: 'fa fa-users',
            applicants: true,
            title: 'Total Applicants',
            results: ['PENDING','COMPLETED','ARCHIVED'],
            value: 0,
            loading: true,
            footerText: 'View',
            footerIcon: 'fa fa-external-link',
          },
          {
            type: 'warning',
            icon: 'ti-timer',
            applicants: true,
            title: 'Pending',
            results: ['PENDING'],
            value: 0,
            loading: true,
            footerText: 'View',
            footerIcon: 'fa fa-external-link',
          },
          {
            type: 'success',
            icon: 'ti-check',
            applicants: true,
            title: 'Completed',
            results: ['COMPLETED'],
            value: 0,
            loading: true,
            footerText: 'View',
            footerIcon: 'fa fa-external-link',
          },
          {
            type: 'none',
            icon: 'fa fa-folder-open-o',
            applicants: true,
            title: 'Archived',
            results: ['ARCHIVED'],
            value: 0,
            loading: true,
            footerText: 'View',
            footerIcon: 'fa fa-external-link',
          }
        ],
        creditStatCard: {
          type: 'info',
          icon: 'fa fa-credit-card',
          verifications: false,
          title: 'Current Credit',
          value: null,
          loading: true,
          footerText: 'Topup',
          footerIcon: 'ti-reload'
        }
      }
    },
    watch: {
      sbBackground (value) {
        this.$sidebar.setBackground(value)
      },
      sbFont (value) {
        this.$sidebar.setFont(value)
      },
      sbActive (value) {
        this.$sidebar.setActive(value)
      }
    },
    mounted () {
      var _this = this

      this.$api.getNotices(null, 'DASHBOARD')
        .then(response => {
          this.notices = response.data.content          
          // if(this.$store.state.username == 'candidate.referencing@experian.com') {
          //   if(this.notices == null) this.notices = []
          //   this.notices.push({message: 'Dear valued client, your invoice account has fallen into significant arears and currently some invoices are 60 days over the payment term of 30 days. Attempts have been made to resolve the outstanding invoices, sadly with no resolution. As such, unless resolved, this account will be transferred to Pre Paid Credit payment only as of the 30th January 2023. Please contact your Account Manager if you have any questions.'})
          // }
        })


      if(this.$store.state.paymentType == 'INSTITUTE' || this.$store.state.paymentType.endsWith('_PARENT')) {
        this.$api.getVerificationMetaData()
          .then(response => {
            if(response.data.pendingCount) {
              this.$store.commit('setOutstandingPendings', response.data.pendingCount)
            }
          })
      }

      if(this.$store.state.isIndividual) {
        this.$api.getApplicationHistory({})
          .then(response => {
            if(response.data.content && response.data.content.length > 0)
              this.applications = []
              response.data.content.forEach(function(summary) {
                _this.$api.getApplication(summary.id)
                  .then(response => {
                    _this.applications.push(response.data)
                  })
              })
            this.applicationsLoading = false
          })
        this.$api.getVerificationHistory({})
          .then(response => {
            this.verifications = response.data.content
            this.verificationsLoading = false
          })
      }

      if(!this.$store.state.isIndividual && this.statsCards && this.statsCards.length > 0) {
        this.statsCards.forEach(function (stat){
          if(stat.verifications) {
            _this.$api.getVerificationMetaData(stat.results)
              .then(response => {
                var value = 0
                if(response.data.resultCounts) {
                  response.data.resultCounts.forEach(result => {
                    value = value + result.value
                  })
                }
                stat.value = value
                stat.loading = false
              })
          } else if(stat.applicants) {
            _this.$api.getApplicantsMetaData(stat.results)
              .then(response => {
                var value = 0
                if(response.data.resultCounts) {
                  response.data.resultCounts.forEach(result => {
                    value = value + result.value
                  })
                }
                stat.value = value
                stat.loading = false
              })
          } else {
            _this.$api.getCreditInfo()
              .then(response => {
                stat.value = accounting.formatMoney(response.data.credit)
                stat.loading = false
              })
          }
        })
      }
    },
    computed: {
      statsCards() {
        var cards = []
        if(this.$store.state.paymentType != 'NONE') {
          cards = cards.concat(this.orgStatsCards)
        }
        if(this.$store.state.hasApplicants) {
          cards = cards.concat(this.applicantStatsCards)
        }
        return cards
      },
      appVerifications(application) {
        var avs = []

        return avs
      },
      nonAppVerifications() {
        var navs = []
        if(this.verifications) {
          this.verifications.forEach(v => {
            var found = false
            if(this.$store.state.dismissed && this.$store.state.dismissed.includes('dv' + v.id)) {
              return // skip current v
            }
            if(this.applications) {
              this.applications.forEach(a => {
                if(a.verifications) {
                  a.verifications.forEach(av => {
                    if(v.id == av.id) {
                      found = true
                    }
                  })
                }
              })
            }
            if(!found) {
              navs.push(v)
            }
          })
        }
        return navs
      },
      otherAllowedCount() {
        var count = 0
        if(this.$store.getters.allowed('emp')) count++
        if(this.$store.getters.allowed('pli')) count++
        if(this.$store.getters.allowed('pce')) count++
        if(this.$store.getters.allowed('hsc')) count++
        return count
      },
      pays() {
        // if(this.application && !this.application.applicantPays) {
        //   return false
        // } else {
          return this.$store.state.paymentType == 'CARD' || this.$store.state.paymentType == 'INVOICE'
        // }
      }
    },
    methods: {
      buildStepsAll(applid, vid, result) {
        var steps = this.buildSteps(vid, result)
        steps.unshift(this.buildStepsApp(applid)[0])
        return steps
      },
      buildStepsApp(applid) {
        var view = () => {
          this.$router.push('application/'+applid+'/start/')
        }
        var appl = {id: 0, title: "Start Application", icon_class: "ti-clipboard", action: view}
        return [appl]
      },
      buildSteps(vid, result) {
        var view = () => {
          this.$router.push('verification/history/' + vid)
        }
        var vdetails = {id: 1, title: "Verification Details", icon_class: "fa fa-th-list"}
        var pending = {id: 2, title: "Pending", icon_class: "fa fa-clock-o"}
        var action = {id: 2, title: "Action Required", icon_class: "fa fa-pencil", action: view, warning: true}
        var completed = {id: 3, title: "Completed", icon_class: "fa fa-check", action: view}
        var steps = [vdetails]
        switch (result) {
          case "REJECTED":
          case "NOT_FOUND":
            steps.push(action)
            steps.push(completed)
            break
          case "PENDING":
            steps.push(pending)
            steps.push(completed)
            break
          case "VERIFIED":
          case "NOT_VERIFIED":
          default: 
            steps.push(pending)
            steps.push(completed)
            break
        }
        return steps
      },
      calcStep(result) {
        switch (result) {
          case "PENDING": return 2
          case "VERIFIED": return 3
          case "NOT_VERIFIED": return 3
          case "REJECTED": return 2
          case "NOT_FOUND": return 2
          default: return 0
        }
      },
      followStatLink (stat) {
        if(stat.verifications) {
          //this.$store.commit('setHistoryFilters', {results: stat.results})
          this.$router.push('/verification/history?result=' + (stat.results.includes('REJECTED') ? 'ACTION' : (stat.results.includes('AWAITING_CONSENT') ? 'INCOMPLETE' : stat.results[0])))
        } else if(stat.applicants) {
          this.$router.push('/applicant/history?status=' +  (stat.title.startsWith('Total') ? 'ALL' : stat.results[0]))
        } else {
          this.$router.push('/credit/buy')
        }
      },
      setSideBarWhite () {
        this.$sidebar.setBackground('white')
        this.$sidebar.setActive('primary')
      },
      setSideBarWhite2 () {
        this.$sidebar.setBackground('white2')
        this.$sidebar.setActive('primary')
      },
      setSideBarWhite3 () {
        this.$sidebar.setBackground('white2')
        this.$sidebar.setActive('default')
      },
      setSideBarSeagrass () {
        this.$sidebar.setBackground('default')
        this.$sidebar.setActive('primary')
      },
      setSideBarGradient () {
        this.$sidebar.setBackground('gradient')
        this.$sidebar.setActive('primary')
      }
    }
  }

</script>

<style>
.partnerLogo {
  float: right; 
  max-width: 20% !important; 
  max-height: 70px !important; 
  object-fit: contain;
  margin-top: 10px;
  margin-bottom: 10px;
}
.btn-center {
  text-align: center;
}

</style>